<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      :deleteLoading="deleteLoading"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />
    <DuplicatePopup
      v-if="duplicatewindow == true"
      :id="idpass"
      @cancelClick="handleDuplicateClose"
    />

    <div class="pt-5 pb-10 max-h-screen overflow-y-auto">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-5 px-6">
        <div
          class="flex flex-col md:flex-col justify-between lg:flex-row items-start gap-2"
        >
          <h1 class="text-2xl font-bold text-primary text-start md:text-left">
            My Courses
          </h1>

          <div
            class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between flex-wrap"
          >
            <!-- Filter Dropdown -->
            <div>
              <select
                name="model_select"
                id="model_select"
                v-model="selected_filter"
                @change="getCourses(1)"
                class="px-4 py-2 w-full md:w-[160px] rounded-xl text-sm text-white bg-blues font-semibold outline-none transition-colors duration-200 hover:bg-blue-600"
              >
                <option value="" disabled selected>Select sorting</option>
                <option value="title">A to Z</option>
                <option value="-title">Z to A</option>
                <option value="-created_at">New to Old</option>
                <option value="created_at">Old to New</option>
              </select>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-wrap gap-2">
              <router-link
                v-if="this.userInfo.user.permission != 'instructor'"
                :to="{ name: 'AdminNewCourses' }"
                class="bg-blues text-white px-4 py-2 rounded-xl text-sm font-semibold outline-none transition-colors duration-200 hover:bg-blue-600"
              >
                Add New Course
              </router-link>

              <!-- <router-link
                :to="{ name: 'AdminStudentAssign' }"
                class="bg-blues text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
              >
                Assign Student
              </router-link> -->

              <!-- <router-link
                :to="{ name: 'AICourseCreate' }"
                class="border border-blues text-blues px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues"
              >
                AI Course Create
              </router-link> -->
            </div>

            <!-- Search Form -->
            <form
              @submit.prevent="getCourses(1)"
              class="w-full md:w-auto flex gap-2 items-center"
            >
              <div
                class="flex w-full md:w-[300px] rounded-xl overflow-hidden"
                style="box-shadow: 0px 2px 20px 0px #105c8e26"
              >
                <input
                  type="text"
                  name="search"
                  id="search"
                  v-model="search_list"
                  @input="getCourses(1)"
                  placeholder="Search The Course"
                  class="flex-1 px-4 py-2 outline-none text-sm text-gray-700"
                />
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-blues hover:bg-[#18469d] cursor-pointer'
                  "
                  class="px-4 flex items-center justify-center"
                >
                  <img
                    src="@/assets/search.webp"
                    alt="Search"
                    class="w-5 h-5"
                  />
                </button>
              </div>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </form>
          </div>
        </div>

        <h1 class="text-lg font-bold text-primary text-start md:text-left">
          Total: {{ course_count || 0 }}
        </h1>

        <div class="flex items-center gap-2 mb-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2l-7 7v5l-4 2v-7L3 6V4z"
            />
          </svg>

          <p class="text-sm font-bold text-slate-800">Field Filters:</p>
        </div>
        <div>
          <div class="grid grid-cols-1 md:grid-cols-6 gap-5">
            <!-- Batch -->
            <select
              id="batch_id"
              v-model="selectedBatchId"
              @change="onBatchChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Batch</option>
              <option
                v-for="batch_year in batch_years"
                :key="batch_year.id"
                :value="batch_year.id"
              >
                {{ batch_year.year }}
              </option>
            </select>

            <!-- Program -->
            <select
              id="program_id"
              v-model="selectedProgramId"
              @change="onProgramChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>

            <!-- Semester -->
            <select
              id="semester_id"
              v-model="selectedSemesterId"
              @change="onSemesterChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Semester</option>
              <option
                v-for="semester in semetser_list"
                :key="semester.id"
                :value="semester.id"
              >
                {{ semester.semester }}
              </option>
            </select>

            <!-- Course Type -->
            <select
              id="coursetype_id"
              v-model="selectedCourseType"
              @change="onCourseTypeChange"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Course type</option>
              <option
                v-for="course_type in course_types"
                :key="course_type.title"
                :value="course_type.title"
              >
                {{ course_type.title }}
              </option>
            </select>

            <!-- Instructor Email -->
            <select
              id="instructor_id"
              v-model="selectedInstructorEmail"
              @change="getCourses(1)"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select instructor email</option>
              <option
                v-for="instructor in instructor_list"
                :key="instructor.email"
                :value="instructor.email"
              >
                {{ instructor.email }}
              </option>
            </select>

            <!-- Instructor Name -->
            <select
              id="instructor_name"
              v-model="selectedInstructorName"
              @change="getCourses(1)"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select instructor name</option>
              <option
                v-for="instructor in instructor_list"
                :key="instructor.display_name"
                :value="instructor.display_name"
              >
                {{ instructor.display_name }}
              </option>
            </select>

            <!-- Status -->
            <select
              id="selected_publish"
              v-model="selectedPublishStatus"
              @change="getCourses(1)"
              class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold capitalize leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 hover:bg-gray-100"
            >
              <option value="" disabled>Select Status</option>
              <option :value="true">Published</option>
              <option :value="false">Unpublished</option>
            </select>

            <button
              type="button"
              @click="clearFilters"
              class="text-blue-600 underline flex items-center text-xs font-semibold gap-1 hover:text-blues"
            >
              <img
                src="@/assets/attendance/cancel.webp"
                alt="Clear"
                class="w-3 h-3 object-contain"
              />
              Clear All
            </button>
          </div>
        </div>

        <div
          v-if="loading"
          class="flex items-center justify-center h-[calc(100vh-350px)]"
        >
          <img src="@/assets/newd/loading.gif" alt="Loading" />
        </div>
        <div v-else>
          <div v-if="courselist.length > 0">
            <div
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10"
            >
              <div
                class="rounded-3xl shadow-md"
                v-for="course in courselist"
                :key="course"
              >
                <div
                  class="flex flex-col h-full justify-between text-start sm:text-left px-4 sm:px-6 py-6"
                >
                  <router-link
                    :to="{
                      name: 'InstructorStudents',
                      params: {
                        course_id: course.id,
                        department_id: course.department.id,
                      },
                    }"
                    class="flex flex-col gap-1 min-h-[300px]"
                  >
                    <img
                      v-if="course.thumbnail"
                      class="object-cover object-center h-[200px] w-full rounded-lg"
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover object-center h-[200px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Default Thumbnail"
                    />

                    <!-- <div class="flex flex-col justify-between">  -->

                    <h1 class="font-bold text-lg text-primary py-2">
                      {{ course.title.slice(0, 50) }}
                      <p
                        v-if="course.title.length > 50"
                        class="text-primary text-sm mt-1 font-semibold"
                      >
                        ...More
                      </p>
                    </h1>

                    <div class="flex flex-col gap-1">
                      <p class="text-sm">
                        <span class="font-semibold">Batch:</span>
                        {{ course?.batch?.year || "NAN" }}
                      </p>

                      <p class="text-sm">
                        <span class="font-semibold">Program:</span>
                        {{ course?.program?.name || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Course Code:</span>
                        {{ course?.course_code || "NAN" }}
                      </p>
                      <!-- <p class="text-sm">
                        <span class="font-semibold">Department: </span
                        >{{ course?.department?.name || "NAN" }}
                      </p> -->
                      <p class="text-sm">
                        <span class="font-semibold">Semester: </span
                        >{{ course?.semester?.semester || "NAN" }}
                      </p>
                      <!-- <p class="text-sm break-words">
                        <span class="font-semibold whitespace-nowrap"
                          >Instructor Email:</span
                        >
                        <span v-if="course.instructor.length > 0">
                          {{ course?.instructor[0].user.email }}
                        </span>
                        <span v-else>NAN</span>
                      </p> -->
                      <p class="text-sm">
                        <span class="font-semibold">Section:</span>
                        {{ course?.class_section || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Course Type:</span>
                        {{ course?.course_type?.title || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Instructor Name:</span>
                        <span v-if="course.instructor.length > 0">
                          {{ course.instructor[0].user.display_name }}
                        </span>
                        <span v-else>NAN</span>
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Publish:</span>
                        {{
                          course?.is_published === true
                            ? "Published"
                            : course?.is_published === false
                            ? "Unpublished"
                            : "NA"
                        }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Student Count:</span>
                        {{ course?.student_count || 0 }}
                      </p>
                    </div>
                  </router-link>

                  <div
                    class="mb-5 mt-2 flex items-center gap-2 hidden"
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                  >
                    <button
                      @click="
                        changeInstructorPopup = course.id;
                        findinstructor(course.id);
                      "
                      class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Change Instructor
                    </button>

                    <!--  -->
                    <router-link
                      :to="{
                        name: 'InstructorStudents',
                        params: {
                          course_id: course.id,
                          department_id: course.department.id,
                        },
                      }"
                      class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Dashboard
                    </router-link>
                  </div>

                  <div class="flex items-center gap-8 mt-5">
                    <!-- <div @click="editCoursePopup = true; currentId = course.id">
                    <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                  </div> -->

                    <!-- <div
                    @click="
                      addLessonUnitPopup = true;
                      currentId = course.id;
                    "
                  >
                    <img src="@/assets/newd/icon1.svg" alt="Add Course" class=" cursor-pointer" />
                  </div> -->

                    <!-- AddLessonUnit -->

                    <router-link
                      :to="{
                        name: 'AddLessonUnit',
                        params: { course_id: course.id },
                      }"
                      class="flex flex-col gap-1"
                    >
                      <div class="relative group">
                        <img
                          src="@/assets/newd/icon1.svg"
                          alt="Add Course"
                          class="cursor-pointer"
                        />
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Add
                        </span>
                      </div>
                    </router-link>

                    <router-link
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                      :to="{
                        name: 'InstructorCourseEdit',
                        params: { course_id: course.id },
                      }"
                      class="flex flex-col gap-1"
                    >
                      <div class="relative group">
                        <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Edit
                        </span>
                      </div>
                    </router-link>

                    <div
                      @click="
                        titlepass = course.title;
                        popupwindow = true;
                        idpass = course.id;
                      "
                      class="cursor-pointer"
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                    >
                      <div class="relative group">
                        <img
                          src="@/assets/newd/icon3.svg"
                          alt="Delete Course"
                        />
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Delete
                        </span>
                      </div>
                    </div>
                    <!-- <div
                      @click="DuplicateCourse(course.id)"
                      class="cursor-pointer"
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                    >
                      <div class="relative group">
                        <img
                          src="@/assets/newd/duplicate.svg"
                          alt="Duplicate Course"
                        />
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Duplicate
                        </span>
                      </div>
                    </div> -->
                    <div
                      @click="
                        duplicatewindow = true;
                        idpass = course.id;
                      "
                      class="cursor-pointer"
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                    >
                      <div class="relative group">
                        <img
                          src="@/assets/newd/duplicate.svg"
                          alt="Duplicate Course"
                        />
                        <span
                          class="absolute top-8 z-40 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 whitespace-nowrap py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          Duplicate
                        </span>
                      </div>
                    </div>

                    <router-link
                      :to="{
                        name: 'AdminCoursePreview',
                        params: { course_id: course.id },
                      }"
                      class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-600 outline-none"
                    >
                      Preview
                    </router-link>

                    <!-- <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                  >
                    C
                  </router-link> -->
                  </div>

                  <!-- DuplicateCourse -->
                  <!-- <div
                    class="mt-3"
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                  >
                    <button
                      @click="DuplicateCourse(course.id)"
                      class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Duplicate
                    </button>
                  </div> -->

                  <!-- </div> -->
                </div>
              </div>
            </div>

            <Pagination
              :totalPages="totalPages"
              ref="paginationRef"
              @page-changed="this.getCourses"
            />
          </div>

          <div v-else class="text-lg font-normal text-center">
            No data Found
          </div>

          <!-- {{ pageArray }} -->
        </div>
      </div>
    </div>

    <div
      v-if="addLessonUnitPopup"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0"
    >
      <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      />
    </div>

    <div
      v-if="changeInstructorPopup != null"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex justify-center items-center"
    >
      <div
        class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10 my-10 pb-10"
      >
        <div class="pb-10">
          <form
            ref="changeInsRef"
            @submit.prevent="completeUnitStart"
            class="rounded-3xl py-10 px-10 pb-2 heightfix bg-white overflow-y-auto flex flex-col gap-5"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
          >
            <div class="flex items-center justify-end gap-4">
              <button
                @click="changeInstructorPopup = null"
                class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full cursor-pointer"
              >
                Close
              </button>
            </div>

            <div class="flex flex-col gap-3 hidden">
              <label class="text-sm">Select Faculty </label>
              <select
                id="instructor"
                class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
              >
                <option value="" disabled>Select Faculty</option>
                <option
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  :value="instructor.id"
                >
                  {{ instructor.user.email }}
                </option>
              </select>
            </div>

            <div class="flex flex-col gap-3">
              <label class="text-sm font-medium">Select Faculty</label>
              <ul
                class="w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1 p-2 space-y-2"
                :class="
                  instructor_lists.length === 0 ? 'bg-gray-200' : 'bg-white'
                "
              >
                <li
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  class="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    :value="instructor.id"
                    v-model="selectedInstructors"
                    class="form-checkbox accent-blue-600"
                  />
                  <span>{{ instructor.user.email }}</span>
                </li>
              </ul>
            </div>

            <div class="pb-8 flex items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-4 py-2"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />-->
            </div>
          </form>
        </div>
      </div>
      <!-- <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      /> -->
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";
import Pagination from "@/components/Pagination.vue";
import DuplicatePopup from "@/components/DuplicatePopup.vue";

export default {
  components: {
    Header,
    FlashMessage,
    ConfirmPopup,
    AddLessonUnit,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
    Pagination,
    DuplicatePopup,
  },

  data() {
    return {
      // Popup states
      changeInstructorPopup: null,
      popupwindow: false,
      duplicatewindow: false,
      addLessonUnitPopup: false,

      // Data
      courselist: [],
      instructorInfo: "",
      messages: "",
      loading: true,
      search_list: "",
      searchTimeout: null,
      currentId: null,
      totalPages: 1,
      current_page: 1,
      pageSize: 5,
      pageArray: [],
      course_count: null,
      disable_submit: false,
      selectedInstructors: [],
      titlepass: "",
      idpass: null,

      // Filter data
      batch_years: [],
      programs: [],
      semetser_list: [],
      course_types: [],
      instructor_list: [],
      instructor_lists: [],

      // Selected filter values
      selectedBatchId: "",
      selectedProgramId: "",
      selectedSemesterId: "",
      selectedCourseType: "",
      selectedInstructorEmail: "",
      selectedInstructorName: "",
      selectedPublishStatus: "",
      selected_filter: "",
      deleteLoading: false,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  async created() {
    await this.getbatch();
    await this.getInstructorList();
    await this.getCourses(1);
  },

  methods: {
    // Batch Methods
    async getbatch() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`,
        );
        this.batch_years = res.data.data || [];
      } catch (err) {
        console.error("Error fetching batches:", err);
        this.batch_years = [];
      }
    },

    async onBatchChange() {
      // Reset dependent filters
      this.selectedProgramId = "";
      this.selectedSemesterId = "";
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";
      this.selectedPublishStatus = "";

      // Clear dependent dropdowns
      this.programs = [];
      this.semetser_list = [];
      this.course_types = [];
      this.instructor_list = [];

      if (this.selectedBatchId) {
        await this.getProgramsByBatch(this.selectedBatchId);
      }

      this.getCourses(1);
    },

    async getProgramsByBatch(batchId) {
      if (!batchId) {
        this.programs = [];
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${batchId}&Key=${this.userInfo.token_key}`,
        );
        this.programs = res.data.data || [];
      } catch (err) {
        console.error("Error fetching programs:", err);
        this.programs = [];
      }
    },

    // Program Methods
    async onProgramChange() {
      // Reset dependent filters
      this.selectedSemesterId = "";
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";

      // Clear dependent dropdowns
      this.semetser_list = [];
      this.course_types = [];
      this.instructor_list = [];

      if (this.selectedProgramId && this.selectedBatchId) {
        await this.getSemestersByProgramAndBatch();
      }

      this.getCourses(1);
    },

    async getSemestersByProgramAndBatch() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__program__id=${this.selectedProgramId}&batch__id=${this.selectedBatchId}`,
        );
        this.semetser_list = res.data.data || [];
      } catch (err) {
        console.error("Error fetching semesters:", err);
        this.semetser_list = [];
      }
    },

    // Semester Methods
    async onSemesterChange() {
      // Reset dependent filters
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";

      // Clear dependent dropdowns
      this.course_types = [];
      this.instructor_list = [];

      if (this.selectedProgramId && this.selectedSemesterId) {
        await this.getCourseTypes();
      }

      this.getCourses(1);
    },

    async getCourseTypes() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}&program_id=${this.selectedProgramId}&semester_id=${this.selectedSemesterId}`,
        );
        this.course_types = res.data.data || [];
      } catch (err) {
        console.error("Error fetching course types:", err);
        this.course_types = [];
      }
    },

    // Course Type Methods
    async onCourseTypeChange() {
      // Reset dependent filters
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";

      // Clear dependent dropdowns
      this.instructor_list = [];

      if (
        this.selectedCourseType &&
        this.selectedProgramId &&
        this.selectedSemesterId
      ) {
        await this.getInstructorsByFilters();
      }

      this.getCourses(1);
    },

    async getInstructorsByFilters() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/instructor-filterset-get/?Key=${this.userInfo.token_key}&course_type=${this.selectedCourseType}&program_id=${this.selectedProgramId}&semester_id=${this.selectedSemesterId}`,
        );
        this.instructor_list = (res.data.data || []).filter(
          (item) => item.display_name != null,
        );
      } catch (err) {
        console.error("Error fetching instructors:", err);
        this.instructor_list = [];
      }
    },

    // Instructor Methods
    async getInstructorList() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`,
        );
        this.instructor_lists = res.data.products || [];
      } catch (err) {
        console.error("Error fetching instructors:", err);
        this.instructor_lists = [];
      }
    },

    findinstructor(course_id) {
      const course = this.courselist.find((c) => c.id === course_id);
      if (course && course.instructor) {
        this.selectedInstructors = course.instructor.map(
          (instructor) => instructor.id,
        );
      } else {
        this.selectedInstructors = [];
      }
    },

    async completeUnitStart() {
      this.disable_submit = true;
      const instructorIds = this.selectedInstructors.map(Number);

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/categoryinstructorupdate/${this.changeInstructorPopup}/?Key=${this.userInfo.token_key}`,
          {
            id: this.changeInstructorPopup,
            instructor: instructorIds,
          },
        );

        if (response.data.status == "200") {
          this.messages = {
            text: "Instructor Changed Successfully.",
            type: "success",
          };
          setTimeout(() => {
            if (this.$refs.changeInsRef) this.$refs.changeInsRef.reset();
            this.getCourses(1);
            this.changeInstructorPopup = null;
            this.messages = { text: "", type: "" };
          }, 2000);
        } else {
          this.messages = {
            text: "Error Issue.",
            type: "error",
          };
          setTimeout(() => {
            this.messages = { text: "", type: "" };
          }, 2000);
        }
      } catch (err) {
        console.error(err);
        this.messages = {
          text: "Something went wrong.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;
      }
    },

    handleDuplicateClose() {
      this.duplicatewindow = false;
      this.getCourses(1);
    },

    handleSearchDebounced() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getCourses(1);
      }, 500);
    },

    async getCourses(page) {
      this.current_page = page;

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("Key", this.userInfo.token_key);

      if (this.selectedBatchId) params.append("batch_id", this.selectedBatchId);
      if (this.selectedProgramId)
        params.append("program_id", this.selectedProgramId);
      if (this.selectedSemesterId)
        params.append("semester_id", this.selectedSemesterId);
      if (this.selectedCourseType)
        params.append("course_type", this.selectedCourseType);
      if (this.selectedInstructorEmail)
        params.append("instructor_email", this.selectedInstructorEmail);
      if (this.selectedInstructorName)
        params.append("instructor_name", this.selectedInstructorName);
      if (this.selectedPublishStatus !== "")
        params.append("is_published", this.selectedPublishStatus);
      if (this.search_list) params.append("search", this.search_list);
      if (this.selected_filter) params.append("ordering", this.selected_filter);

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/courses/?${params.toString()}`,
        );

        if (response.data.status == 200) {
          this.totalPages = response.data.data.total_page;
          this.current_page = response.data.data.current_page;
          this.courselist = response.data.data.data.data || [];
          this.course_count = response.data.data.total || 0;
        } else {
          this.course_count = 0;
          this.courselist = [];
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        this.course_count = 0;
        this.courselist = [];
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    async deletecourse(data) {
      this.deleteLoading = true;

      try {
        const response = await axios.delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`,
        );

        if (response.status == 204) {
          this.messages = {
            text: "Deleted successfully",
            type: "success",
          };

          this.popupwindow = false;

          setTimeout(() => {
            this.getCourses(1);
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        } else {
          this.messages = {
            text: "Delete Failed",
            type: "error",
          };
        }
      } catch (err) {
        console.error(err);

        this.messages = {
          text: "Delete Failed",
          type: "error",
        };
      } finally {
        this.deleteLoading = false;
      }
    },

    async filterorder() {
      if (!this.selected_filter) return;

      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/courses/?ordering=${this.selected_filter}&Key=${this.userInfo.token_key}`,
        );

        if (response.data.status == 200) {
          this.totalPages = response.data.data.total_page;
          this.current_page = response.data.data.current_page;
          this.courselist = response.data.data.data.data || [];
          this.course_count = response.data.data.total || 0;
        } else {
          this.courselist = [];
          this.course_count = 0;
        }
      } catch (err) {
        console.error("Error sorting courses:", err);
        this.courselist = [];
      } finally {
        this.loading = false;
      }
    },

    clearFilters() {
      // Reset all selected values
      this.selectedBatchId = "";
      this.selectedProgramId = "";
      this.selectedSemesterId = "";
      this.selectedCourseType = "";
      this.selectedInstructorEmail = "";
      this.selectedInstructorName = "";
      this.selectedPublishStatus = "";
      this.selected_filter = "";
      this.search_list = "";

      // Clear dropdown data
      this.programs = [];
      this.semetser_list = [];
      this.course_types = [];
      this.instructor_list = [];

      // Reload courses
      this.getCourses(1);
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
